import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./happy-admin-theme.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { HashRouter as Router } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import './language/i18n';
import store from "../src/app/store";
import { SystemSettingProvider } from "./context/SystemSettingContext";
import axios from "axios";
import swal from "sweetalert";

// Interceptor toàn cục: Bắt tất cả các phản hồi từ chối đối với tài khoản Chỉ Xem (Read-Only)
let isBlockingSwalOverride = false;
let swalOverrideTimeout = null;
let lastBlockedMessage = "";

const enforceReadOnlyModal = (msg) => {
    isBlockingSwalOverride = true;
    lastBlockedMessage = msg || "";
    if (swalOverrideTimeout) clearTimeout(swalOverrideTimeout);
    swalOverrideTimeout = setTimeout(() => {
        isBlockingSwalOverride = false;
    }, 2500);

    swal("Thông báo", lastBlockedMessage, "warning");

    // Tự động tắt mọi loader / spinner đang xoay trên giao diện
    setTimeout(() => {
        document.querySelectorAll(".loading, .loader, [class*='loader']").forEach((el) => {
            const parent = el.closest(".loading") || el.parentElement;
            if (parent && parent !== document.body) {
                parent.style.display = "none";
            }
        });
    }, 50);
};

// Chặn không cho các hàm .catch() gắn cứng trong từng component đè lên thông báo Chỉ Xem, và tô màu xanh cho @username
if (typeof window !== "undefined" && window.MutationObserver) {
    const observer = new MutationObserver(() => {
        const titleEl = document.querySelector(".swal-title");
        const textEl = document.querySelector(".swal-text");

        if (isBlockingSwalOverride) {
            if (titleEl && titleEl.textContent !== "Thông báo") {
                titleEl.textContent = "Thông báo";
            }
            if (textEl && lastBlockedMessage) {
                const cleanUser = lastBlockedMessage.replace(/\n/g, "<br/>").replace(
                    /(@[a-zA-Z0-9_]+)/g,
                    (match) => `<a href="https://t.me/${match.replace('@', '')}" target="_blank" rel="noopener noreferrer" style="color: #1890ff; font-weight: bold; text-decoration: none;">${match}</a>`
                );
                if (textEl.innerHTML !== cleanUser) {
                    textEl.innerHTML = cleanUser;
                }
            }
            const iconEl = document.querySelector(".swal-icon");
            if (iconEl && !iconEl.classList.contains("swal-icon--warning")) {
                iconEl.className = "swal-icon swal-icon--warning";
                iconEl.innerHTML = '<span class="swal-icon--warning__body"><span class="swal-icon--warning__dot"></span></span>';
            }
        } else if (textEl && textEl.innerHTML && textEl.innerHTML.includes("@") && !textEl.querySelector("a")) {
            textEl.innerHTML = textEl.innerHTML.replace(
                /(@[a-zA-Z0-9_]+)/g,
                (match) => `<a href="https://t.me/${match.replace('@', '')}" target="_blank" rel="noopener noreferrer" style="color: #1890ff; font-weight: bold; text-decoration: none;">${match}</a>`
            );
        }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
}

axios.interceptors.response.use(
    (response) => {
        if (response?.data && response.data.isReadOnlyBlocked) {
            enforceReadOnlyModal(response.data.message);
            const err = new Error(response.data.message);
            err.isReadOnlyBlocked = true;
            return Promise.reject(err);
        }
        return response;
    },
    (error) => {
        const errorMsg = error.response?.data?.message || "";
        const isBlocked = error.response?.data?.isReadOnlyBlocked || errorMsg.includes("quyền xem");
        if (isBlocked) {
            enforceReadOnlyModal(errorMsg);
            error.isReadOnlyBlocked = true;
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <SystemSettingProvider>
            <React.Suspense fallback={<div className="admin-theme">...</div>}>
                <AnimatePresence wait>
                    <Router>
                        <App />
                    </Router>
                </AnimatePresence>
            </React.Suspense>
        </SystemSettingProvider>
    </Provider>
);
reportWebVitals();
